const components = [{
    title: "飞线图",
    tag: "de-flyline",
    group: "map",
    props: [{
      title: "飞线类型",
      name: "飞线配置",
      type: {
        name: "de-flyline-attr"
      }
    }]
  },
  {
    title: "室内热力图",
    tag: "de-indoor-heatmap",
    resizeMethod: "resize",
    group: "map",
    props: [{
        title: "请求地址",
        name: "url",
        type: {
          name: "text"
        },
        default: "/testdata/heatData.json"
      },
      {
        title: "热力半径",
        name: "radius",
        type: {
          name: "text"
        },
        default: 30
      },
      {
        title: "热力透明",
        name: "opacity",
        type: {
          name: "text"
        },
        default: 0.7
      },
      {
        title: "循环间隔",
        name: "loopTime",
        type: {
          name: "text"
        },
        default: 5000
      }
    ]
  },
  // {
  //   title: "3D地球",
  //   tag: "de-earth",
  //   group: "map",
  //   props: []
  // },
  {
    title: "武汉飞线图",
    tag: "de-wh-fly-map",
    group: "",
  },
  {
    title: "省份人口流入",
    tag: "de-china-map-fly-person",
    group: "",
    resizeMethod: 'resize',
    props: [{
        title: "省份名称",
        name: "cityName",
        type: {
          name: 'text'
        },
        default: '北京市'
      },
      {
        title: "省份数据",
        name: "cityData",
        type: {
          name: 'data-json'
        },
        default: []
      }
    ]
  },
  {
    title: "北京重点小区监控",
    tag: "de-beijing-effect-scatter",
    group: "",
    resizeMethod: 'resize',
  },
  {
    title: "成都健康关注指数",
    tag: "de-chendu-heatmap",
    group: "",
    resizeMethod: 'resize',
  },
  {
    title: "热力图",
    tag: "de-heat-map",
    group: "map",
    resizeMethod: 'resize',
    props: [{
        title: "经度",
        name: "lng",
        type: {
          name: 'text'
        },
        default: '103.81599968947137'
      },
      {
        title: "纬度",
        name: "lat",
        type: {
          name: 'text'
        },
        default: '30.78152098571051'
      },

      {
        title: "zoom",
        name: "zoom",
        type: {
          name: 'number'
        },
        default: 10
      },
      {
        title: "zoom min",
        name: "zoomMin",
        type: {
          name: 'number'
        },
        default: 3
      },
      {
        title: "zoom max",
        name: "zoomMax",
        type: {
          name: "number"
        },
        default: 19
      },
      {
        title: "zoom大小",
        name: "zoomTool",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "放缩",
        name: "mouseZoom",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "拖拽",
        name: "drag",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "样式",
        name: "mapStyle",
        type: {
          name: 'data-json'
        },
        default: []
      },
      {
        title: "地图文字",
        name: "isLabelText",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "数据源",
        name: "api",
        type: {
          name: 'text'
        },
        default: '../default-data/point-data.json'
      },
      {
        title: "显示地图",
        name: "showMap",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "gradient",
        name: "gradient",
        type: {
          name: "literal"
        },
        default: {
          0.55: 'rgb(0,255,0)',
          0.85: 'yellow',
          1.0: 'rgb(255,0,0)'
        }
      },
      {
        title: "半径",
        name: "radius",
        type: {
          name: "number"
        },
        default: 17
      },
      {
        title: "权重",
        name: "maxValue",
        type: {
          name: "text"
        },
        default: ""
      },
      {
        title: "透明度",
        name: "opacity",
        type: {
          name: "number"
        },
        default: 1
      },
      {
        title: "地图缩放",
        name: "scale",
        type: {
          name: 'number',
          options: {
            min: 0,
            step: 0.1,
            // max: 1
          }
        },
        default: 1
      },
    ]
  },
  {
    title: "地图散点",
    tag: "de-point-map",
    group: "map",
    resizeMethod: 'resize',
    props: [{
        title: "经度",
        name: "lng",
        type: {
          name: 'text'
        },
        default: '103.81599968947137'
      },
      {
        title: "纬度",
        name: "lat",
        type: {
          name: 'text'
        },
        default: '30.78152098571051'
      },

      {
        title: "zoom",
        name: "zoom",
        type: {
          name: 'number'
        },
        default: 10
      },
      {
        title: "zoom min",
        name: "zoomMin",
        type: {
          name: 'number'
        },
        default: 3
      },
      {
        title: "zoom max",
        name: "zoomMax",
        type: {
          name: "number"
        },
        default: 19
      },
      {
        title: "显示zoom",
        name: "zoomTool",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "滚轮放缩",
        name: "mouseZoom",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "地图拖拽",
        name: "drag",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "地图样式",
        name: "mapStyle",
        type: {
          name: 'data-json'
        },
        default: []
      },
      {
        title: "地图文字",
        name: "isLabelText",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "数据地址",
        name: "api",
        type: {
          name: 'text'
        },
        default: '../default-data/point-data2.json'
      },
      {
        title: "显示地图",
        name: "showMap",
        type: {
          name: "bool"
        },
        default: true
      },

      {
        title: "透明度",
        name: "opacity",
        type: {
          name: "number"
        },
        default: 1
      },
      {
        title: "图标",
        name: "symbol",
        type: {
          name: "map-symbol"
        },
        default: 'circle'
      },
      {
        title: "图标大小",
        name: "symbolSize",
        type: {
          name: "number"
        },
        default: 20
      },
      {
        title: "地图缩放",
        name: "scale",
        type: {
          name: 'number',
          options: {
            min: 0,
            step: 0.1,
            // max: 1
          }
        },
        default: 1
      },
      
    ]
  },

  {
    title: "地图围栏",
    tag: "de-polygon-2d",
    group: "map",
    resizeMethod: 'resize',
    props: [
      //----  关联区域 start
      {
        title: "围栏",
        name: "name",
        type: {
          name: 'map-polygon-select',
        },
        default: ""
      },
      {
        title: "经度",
        name: "lng",
        type: {
          name: 'text'
        },
        default: '105.2141942496418'
      },
      {
        title: "纬度",
        name: "lat",
        type: {
          name: 'text'
        },
        default: '38.32113002834947'
      },

      {
        title: "zoom",
        name: "zoom",
        type: {
          name: 'number'
        },
        default: 5
      },
      //----  关联区域 end

      {
        title: "zoom min",
        name: "zoomMin",
        type: {
          name: 'number'
        },
        default: 3
      },
      {
        title: "zoom max",
        name: "zoomMax",
        type: {
          name: "number"
        },
        default: 19
      },
      {
        title: "显示zoom",
        name: "zoomTool",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "滚轮放缩",
        name: "mouseZoom",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "地图拖拽",
        name: "drag",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "地图样式",
        name: "mapStyle",
        type: {
          name: 'data-json'
        },
        default: []
      },
      {
        title: "地图文字",
        name: "isLabelText",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "数据地址",
        name: "api",
        type: {
          name: 'text'
        },
        default: ''
      },
      {
        title: "显示地图",
        name: "showMap",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "显示浮层",
        name: "isTooltip",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "浮层内容",
        name: "tooltip",
        type: {
          name: "text",
          options: {
            rows: 4

          }
        },
        default: "{name}+'：'+{count}"
      },
      {
        title: "显示图例",
        name: "isLegend",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "图例标题",
        name: "legendTitle",
        type: {
          name: "text"
        },
        default: '图例标题'
      },
      {
        title: "围栏透明度",
        name: "opacity",
        type: {
          name: 'number',
          options: {
            min: 0,
            step: 0.1,
            max: 1
          }
        },
        default: 0.7
      },
      {
        title: "围栏文字",
        name: "isLabel",
        type: {
          name: "bool"
        },
        default: true
      },
      {
        title: "地图缩放",
        name: "scale",
        type: {
          name: 'number',
          options: {
            min: 0,
            step: 0.1,
            // max: 1
          }
        },
        default: 1
      },
    ]
  },
];
export default components;